<div class="animated fadeIn" style="background-color: white; padding: 1rem">
	<!-- Mostrar ADMIN solo si es admin y NO hay cliente seleccionado; de lo contrario, vistaCliente -->
	<div *ngIf="isAdmin && !selectedClientId; else vistaCliente">
		<div class="row">
			<!-- Totales por Cliente -->
			<div class="col-12 col-lg-6 mb-4 d-flex">
				<div class="card flex-grow-1">
					<div class="card-body d-flex flex-column">
						<h5 class="card-title">
							Reproducciones Totales por Cliente
						</h5>
						<div style="height: 300px">
							<canvas
								baseChart
								[datasets]="barChartClienteData"
								[labels]="barChartClienteLabels"
								[options]="barChartOptions"
								[colors]="barChartColours"
								[legend]="barChartLegend"
								[chartType]="barChartType"
							>
							</canvas>
						</div>
					</div>
				</div>
			</div>

			<!-- Reproducciones por Publicidad -->
			<div class="col-12 col-lg-6 mb-4 d-flex">
				<div class="card flex-grow-1">
					<div class="card-body d-flex flex-column">
						<h5 class="card-title">
							Reproducciones por Publicidad
						</h5>
						<div style="height: 300px; overflow-x: auto">
							<canvas
								baseChart
								[datasets]="barChartMediaData"
								[labels]="barChartMediaLabels"
								[options]="barChartOptions"
								[colors]="barChartColours"
								[legend]="barChartLegend"
								[chartType]="barChartType"
							>
							</canvas>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Apartado: Unidades Conectadas (solo en vista Admin) -->
		<div class="row">
			<div class="col-12 mb-4 d-flex">
				<div class="card flex-grow-1">
					<div class="card-body d-flex flex-column">
						<div
							class="d-flex justify-content-between align-items-center mb-2"
						>
							<h5 class="card-title mb-0">Unidades conectadas</h5>

							<div class="d-flex gap-2"></div>
						</div>

						<div
							class="table-responsive"
							*ngIf="connectedUnits?.length; else vacioConex"
						>
							<table class="table table-sm table-hover">
								<thead>
									<tr>
										<th
											(click)="sortBy('name', 'text')"
											style="cursor: pointer"
										>
											Nombre
											<span *ngIf="sortField === 'name'">
												{{
													sortDirection === "asc"
														? "▲"
														: "▼"
												}}
											</span>
										</th>
										<th
											(click)="sortBy('last_connection', 'date')"
											style="cursor: pointer"
										>
											Última conexión
											<span *ngIf="sortField === 'last_connection'">
												{{
													sortDirection === "asc"
														? "▲"
														: "▼"
												}}
											</span>
										</th>
										<!-- <th>Última evidencia</th>
                    <th>Último visto</th> -->
										<th
											(click)="sortBy('is_connected', 'text')"
											style="cursor: pointer"
										>
											Estado
											<span *ngIf="sortField === 'is_connected'">
												{{
													sortDirection === "asc"
														? "▲"
														: "▼"
												}}
											</span>
										</th>
										<th
											(click)="sortBy('bw', 'number')"
											style="cursor: pointer"
										>
											Consumo (GB)
											<span *ngIf="sortField === 'bw'">
												{{
													sortDirection === "asc"
														? "▲"
														: "▼"
												}}
											</span>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let u of connectedUnits">
										<td>{{ u.name }}</td>
										<td>
											{{
												formatDateTime(
													u.last_connection
												) || "-"
											}}
										</td>
										<!-- <td>
                      <ng-container *ngIf="u.lastEvidence?.date; else sinEv">{{ u.lastEvidence.date }}</ng-container>
                      <ng-template #sinEv>-</ng-template>
                    </td>
                    <td>{{ u.last_seen || '-' }}</td> -->
										<td>
											<span
												class="badge"
												[ngClass]="
													u.is_connected
														? 'bg-success'
														: 'bg-secondary'
												"
											>
												{{
													u.is_connected
														? "Conectada"
														: "Desconocido"
												}}
											</span>
										</td>
										<td>
											{{
												(u.bw || 0) /
													(1024 * 1024 * 1024)
													| number : "1.2-2"
											}}
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<ng-template #vacioConex>
							<p class="text-muted text-center mt-3">
								No hay unidades conectadas en la ventana
								seleccionada.
							</p>
						</ng-template>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Vista para CLIENTE (también usada cuando el admin selecciona un cliente) -->
	<ng-template #vistaCliente>
		<div class="row mb-3" *ngIf="!isAdmin">
			<div class="col-md-4">
				<label
					>Rango de días:
					<select
						class="form-control"
						[(ngModel)]="diasSeleccionados"
						(change)="cargarMetricasCliente()"
					>
						<option [value]="7">Últimos 7 días</option>
						<option [value]="15">Últimos 15 días</option>
						<option [value]="30">Últimos 30 días</option>
					</select>
				</label>
			</div>
		</div>

		<!-- Si es admin con cliente seleccionado, puedes opcionalmente mostrar también el selector de días: -->
		<div class="row mb-3" *ngIf="isAdmin && selectedClientId">
			<div class="col-md-4">
				<label
					>Rango de días:
					<select
						class="form-control"
						[(ngModel)]="diasSeleccionados"
						(change)="cargarMetricasCliente(selectedClientId)"
					>
						<option [value]="7">Últimos 7 días</option>
						<option [value]="15">Últimos 15 días</option>
						<option [value]="30">Últimos 30 días</option>
					</select>
				</label>
			</div>
		</div>

		<!-- Serie por día -->
		<div class="row">
			<div class="col-12 mb-4 d-flex">
				<div class="card flex-grow-1">
					<div class="card-body d-flex flex-column">
						<h5 class="card-title">Reproducciones por Día</h5>
						<div
							style="height: 300px"
							*ngIf="lineChartLabels.length > 0; else sinDatos"
						>
							<canvas
								baseChart
								[datasets]="lineChartData"
								[labels]="lineChartLabels"
								[options]="lineChartOptions"
								[legend]="true"
								[chartType]="'line'"
							>
							</canvas>
						</div>
						<ng-template #sinDatos>
							<p class="text-muted text-center mt-4">
								No hay datos disponibles para el período
								seleccionado.
							</p>
						</ng-template>
					</div>
				</div>
			</div>
		</div>

		<!-- Ranking por Grupo -->
		<div class="row">
			<div class="col-12 col-lg-6 mb-4 d-flex">
				<div class="card flex-grow-1">
					<div class="card-body d-flex flex-column">
						<div
							class="d-flex justify-content-between align-items-center"
						>
							<h5 class="card-title mb-0">Vistas por Grupo</h5>
							<small *ngIf="selectedGroupName" class="text-muted"
								>Seleccionado: {{ selectedGroupName }}</small
							>
						</div>
						<div style="height: 300px; overflow-x: auto">
							<canvas
								baseChart
								[datasets]="barChartGrupoData"
								[labels]="barChartGrupoLabels"
								[options]="barChartOptionsClickable"
								[colors]="barChartColours"
								[legend]="false"
								[chartType]="barChartType"
								(chartClick)="onGrupoChartClick($event)"
							>
							</canvas>
						</div>
					</div>
				</div>
			</div>

			<!-- Ranking por Reel -->
			<div class="col-12 col-lg-6 mb-4 d-flex" *ngIf="selectedGroupId">
				<div class="card flex-grow-1">
					<div class="card-body d-flex flex-column">
						<div
							class="d-flex justify-content-between align-items-center"
						>
							<h5 class="card-title mb-0">Vistas por Reel</h5>
							<small *ngIf="selectedReelName" class="text-muted"
								>Seleccionado: {{ selectedReelName }}</small
							>
						</div>
						<div style="height: 300px; overflow-x: auto">
							<canvas
								baseChart
								[datasets]="barChartReelData"
								[labels]="barChartReelLabels"
								[options]="barChartOptionsClickable"
								[colors]="barChartColours"
								[legend]="false"
								[chartType]="barChartType"
								(chartClick)="onReelChartClick($event)"
							>
							</canvas>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Ranking por Media (del reel seleccionado) -->
		<div class="row" *ngIf="selectedReelId">
			<div class="col-12 mb-4 d-flex">
				<div class="card flex-grow-1">
					<div class="card-body d-flex flex-column">
						<div
							class="d-flex justify-content-between align-items-center"
						>
							<h5 class="card-title mb-0">
								Vistas por Media (Reel)
							</h5>
							<button
								class="btn btn-sm btn-outline-secondary"
								(click)="limpiarReel()"
							>
								Quitar selección de Reel
							</button>
						</div>
						<div style="height: 300px; overflow-x: auto">
							<canvas
								baseChart
								[datasets]="barChartMediaDeReelData"
								[labels]="barChartMediaDeReelLabels"
								[options]="barChartOptions"
								[colors]="barChartColours"
								[legend]="false"
								[chartType]="barChartType"
							>
							</canvas>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</div>
